/** Use the selected message text, not the browser's block-container clipboard
 * serialization (which may append extra paragraph breaks). Never trim actual text. */
export function copySelectedMessage(event: ClipboardEvent): void {
  const selection = window.getSelection();
  if (!event.clipboardData || !selection || selection.isCollapsed || selection.rangeCount !== 1) return;
  const range = selection.getRangeAt(0);
  const element = range.startContainer instanceof Element ? range.startContainer : range.startContainer.parentElement;
  const body = element?.closest('.message-body');
  if (!body || !body.contains(range.endContainer) || body.closest('[contenteditable="true"]')) return;
  const fragment = document.createElement('div'); fragment.append(range.cloneContents());
  event.clipboardData.setData('text/plain', selection.toString());
  event.clipboardData.setData('text/html', fragment.innerHTML);
  event.preventDefault();
}
